import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type AttachmentViewerFragment = (
  { __typename: 'Attachment' }
  & Pick<Types.Attachment, 'isMalicious'>
);

export const AttachmentViewerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentViewer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isMalicious' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseAttachmentViewerFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      AttachmentViewerFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseAttachmentViewerFragmentResult
  extends Omit<Apollo.UseFragmentResult<AttachmentViewerFragment>, 'data'> {
  data?: AttachmentViewerFragment;
}

export const useAttachmentViewerFragment = ({
  from,
  returnPartialData,
  ...options
}: UseAttachmentViewerFragmentOptions): UseAttachmentViewerFragmentResult => {
  const result = Apollo.useFragment<AttachmentViewerFragment>({
    ...options,
    fragment: AttachmentViewerFragmentDoc,
    fragmentName: 'AttachmentViewer',
    from: {
      __typename: 'Attachment',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as AttachmentViewerFragment };
};
